import { defineMessages } from 'react-intl';

export const dqlEditorActionsMenuMessages = defineMessages({
  triggerLabel: {
    defaultMessage: 'DQL editor actions',
    id: 'VYHp9Wzie7wOmBmf',
    description: 'Aria label for the DQL editor actions menu trigger button.',
  },
  copyQuery: {
    defaultMessage: 'Copy query',
    id: 'NwDE2g2nYFjxPG9v',
    description: 'Menu item label to copy the DQL query to the clipboard.',
  },
  openDocumentation: {
    defaultMessage: 'Open documentation',
    id: 'XmYqCKn9iEfBoSSL',
    description:
      'Menu item label to open the DQL documentation in a new browser tab.',
  },
  formatQuery: {
    defaultMessage: 'Format query',
    id: '7/hGI/teTlqSMko6',
    description: 'Menu item label to format the DQL query.',
  },
});
